'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var Tile = function Tile(props) {
  var content = props.content,
      callback = props.callback,
      active = props.active,
      index = props.index,
      theme = props.theme;
  var img = content.img,
      text = content.text,
      url = content.url,
      target = content.target,
      fpti = content.fpti;


  return (
    /* eslint-disable-next-line */
    _react2.default.createElement(
      'div',
      {
        id: 'pypl-tile-' + index,
        className: 'pypl-tile ' + theme + ' ' + (active ? 'active' : ''),
        onClick: callback ? function () {
          callback(index, url, target, fpti);
        } : {}
      },
      _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-3' },
          _react2.default.createElement('img', { src: img.src, alt: img.alt })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-9' },
          _react2.default.createElement(
            'p',
            null,
            htmlToReactParser.parse(text)
          )
        )
      )
    )
  );
};

Tile.propTypes = {
  content: _propTypes2.default.shape({
    img: _propTypes2.default.shape({
      src: _propTypes2.default.string.isRequired,
      alt: _propTypes2.default.string.isRequired
    }),
    text: _propTypes2.default.string,
    url: _propTypes2.default.string,
    target: _propTypes2.default.oneOf(['_blank', '_self']),
    fpti: _propTypes2.default.string
  }),
  active: _propTypes2.default.bool,
  callback: _propTypes2.default.func,
  index: _propTypes2.default.number.isRequired,
  theme: _propTypes2.default.oneOf(['theme-background-color-blue-alt', 'theme-background-color-green', 'theme-background-color-purple', 'theme-background-color-pink'])
};

Tile.defaultProps = {
  content: {
    img: {
      src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/emea/gb/en/merchant/smb3/icon2.png',
      alt: ''
    },
    text: '35 characters max',
    url: 'https://www.paypal.com/uk',
    target: '_blank',
    fpti: ''
  },
  active: false,
  callback: function callback() {},
  theme: 'theme-background-color-green'
};

/* eslint-enable */
exports.default = Tile;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/tile/jsx/Tile.js
// module id = 496
// module chunks = 4